export default "__VITE_ASSET__9475eaff__"